import firebase from "firebase/app";
import "firebase/storage";
import User from "@/models/User.js";

const loadFireStore = () => {
	const db = firebase.firestore();
	return db.collection("cerberus_PositionRecord").get();
};

/**
 *
 * @param {File} filed is file to got forn input type file
 * @param {*} path is the directory path of the firebase
 * @returns
 */
const uploadFileToFirebase = async function (filed, path) {
	const that = this;
	const user = new User();
	const userInfo = await user.getUser();
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const storageRef = firebase.storage().ref();
		// File or Blob named mountains.jpg
		const file = filed;
		// Create the file metadata
		const metadata = {
			contentType: file.type,
		};
		// create unique identify date
		const uniqueId = new Date().getTime();
		// Upload file and metadata to the object 'images/mountains.jpg'
		const uploadTask = storageRef
			.child(`serviroutes/${userInfo.serviroutes_company_id}${path}${uniqueId}-${file.name}`)
			.put(file, metadata);
		// Listen for state changes, errors, and completion of the upload.
		uploadTask.on(
			firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
			function (snapshot) {
				// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
				let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				that.progressPercent = progress;
				switch (snapshot.state) {
					case firebase.storage.TaskState.PAUSED: // or 'paused'
						break;
					case firebase.storage.TaskState.RUNNING: // or 'running'
						break;
				}
			},
			function (error) {
				// A full list of error codes is available at
				// https://firebase.google.com/docs/storage/web/handle-errors
				switch (error.code) {
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect error.serverResponse
						break;
				}
				reject(error);
			},
			function () {
				// Upload completed successfully, now we can get the download URL
				uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
					const urls = {
						downloadURL,
						bucketPath: `serviroutes/${userInfo.serviroutes_company_id}${path}${uniqueId}-${file.name}`,
					};
					resolve(urls);
				});
			}
		);
	});
};

const downloadFileFromFirebase = async function (path) {
	const user = new User();
	await user.getUser();
	return new Promise(function (resolve, reject) {
		// Create a root reference
		const storageRef = firebase.storage().ref();
		// Create a reference to the file we want to download
		const starsRef = storageRef.child(path);
		// Get the download URL
		starsRef
			.getDownloadURL()
			.then(function (url) {
				// Insert url into an <img> tag to "download"
				resolve(url);
			})
			.catch(function (error) {
				// A full list of error codes is available at
				// https://firebase.google.com/docs/storage/web/handle-errors
				switch (error.code) {
					case "storage/object-not-found":
						// File doesn't exist
						break;
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect the server response
						break;
				}
				reject(error);
			});
	});
};

const downloadFileFromStorage = function (gsPath) {
	return new Promise(function (resolve, reject) {
		// Create a root reference
		let storage = firebase.storage();
		// Create a reference from a Google Cloud Storage URI
		let gsReference = storage.refFromURL(gsPath);
		// Get the download URL
		gsReference
			.getDownloadURL()
			.then(function (url) {
				// Insert url into an <img> tag to "download"
				resolve(url);
			})
			.catch(function (error) {
				// A full list of error codes is available at
				// https://firebase.google.com/docs/storage/web/handle-errors
				switch (error.code) {
					case "storage/object-not-found":
						// File doesn't exist
						break;
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect the server response
						break;
				}
				reject(error);
			});
	});
};

const uploadCompanyLogo = async function (filed, path) {
	const that = this;

	return new Promise(function (resolve, reject) {
		// Create a root reference
		const storageRef = firebase.storage().ref();
		// File or Blob named mountains.jpg
		const file = filed;
		// Create the file metadata
		const metadata = {
			contentType: file.type,
		};
		// create unique identify date
		const uniqueId = new Date().getTime();
		// Upload file and metadata to the object 'images/mountains.jpg'
		const uploadTask = storageRef.child(`${path}${uniqueId}-${file.name}`).put(file, metadata);
		// Listen for state changes, errors, and completion of the upload.
		uploadTask.on(
			firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
			function (snapshot) {
				// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
				let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				that.progressPercent = progress;
				switch (snapshot.state) {
					case firebase.storage.TaskState.PAUSED: // or 'paused'
						break;
					case firebase.storage.TaskState.RUNNING: // or 'running'
						break;
				}
			},
			function (error) {
				// A full list of error codes is available at
				// https://firebase.google.com/docs/storage/web/handle-errors
				switch (error.code) {
					case "storage/unauthorized":
						// User doesn't have permission to access the object
						break;
					case "storage/canceled":
						// User canceled the upload
						break;
					case "storage/unknown":
						// Unknown error occurred, inspect error.serverResponse
						break;
				}
				reject(error);
			},
			function () {
				// Upload completed successfully, now we can get the download URL
				uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
					const urls = {
						downloadURL,
						bucketPath: `${path}${uniqueId}-${file.name}`,
					};
					resolve(urls);
				});
			}
		);
	});
};

const removeFileFromFirebase = function (bucketPath) {
	return new Promise((resolve, reject) => {
		(async () => {
			const storageRef = firebase.storage().ref();
			// Create a reference to the file to delete
			const desertRef = storageRef.child(bucketPath);
			try {
				// Delete the file
				await desertRef.delete();
				resolve("File deleted");
			} catch (error) {
				reject(new Error("Error delete"));
			}
		})();
	});
};

const listAllFilesFromFirebaseFolder = (folderName) => {
	return new Promise((resolve, reject) => {
		(async () => {
			const storageRef = firebase.storage().ref();
			// Create a reference under which you want to list
			const listRef = storageRef.child(folderName);
			try {
				// Find all the prefixes and items.
				const listFiles = await listRef.listAll();
				if (listFiles.items.length > 0) {
					resolve(listFiles.items);
				} else {
					resolve([]);
				}
			} catch (error) {
				reject(new Error("Error delete"));
			}
		})();
	});
};

export {
	loadFireStore,
	uploadFileToFirebase,
	downloadFileFromFirebase,
	downloadFileFromStorage,
	uploadCompanyLogo,
	removeFileFromFirebase,
	listAllFilesFromFirebaseFolder,
};
